module.exports = __webpack_public_path__ + "img/khimki_bc_group.82d217f0.svg";